export const actions = {
  set_state: 'admin_affiliate/set_state',
  get_affiliates: 'admin_affiliate/get_affiliates',
  update_affiliates: 'admin_affiliate/update_affiliates',
  create_affiliates: 'admin_affiliate/create_affiliates',
  delete_affiliates: 'admin_affiliate/delete_affiliates',
  get_one: 'admin_affiliate/get_one'
}
